import CreditScoreIcon from '@mui/icons-material/CreditScore';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';

import { Box, styled, Typography, type TypographyProps } from '@mui/material';

import { proAccountThemeCoreUI } from '../themes';

const StyledTypography = styled(Typography)(({ theme }) => ({
  lineHeight: '22px',
  fontWeight: '500',
  fontSize: '0.75rem',
  backgroundColor: theme.palette.common.white,
  display: 'inline-block',
  whiteSpace: 'nowrap',
}));

export type BenefitsStatusIconProps = {
  status: 'Commissioned' | 'Commissionable' | 'Promo' | undefined;
  label?: string;
  labelProps?: TypographyProps;
};

/**
 * Props for configuring a benefits status icon component from [MicroLibraryCoreUI](https://dev.azure.com/orcha/MicroLibraryTemplate/_git/MicroLibraryCoreUI)
 *
 * @property {string} status - The status of the benefits.
 * @property {string} [label] - The label to display.
 * @property {TypographyProps} [labelProps] - The props for the label.
 */
export const BenefitsStatusIcon = ({
  status,
  label,
  labelProps,
}: BenefitsStatusIconProps) => {
  const getIconColour = () => {
    if (status === 'Commissionable') {
      return '#E31C79';
    }
    if (status === 'Commissioned') {
      return '#009FCE';
    }
    if (status === 'Promo') {
      return '#4CAF50';
    }
    return undefined;
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: proAccountThemeCoreUI.spacing(1),
      }}
      data-testid="app-benefits-status-icon"
    >
      {(status === 'Commissionable' || status === 'Commissioned') && (
        <CreditScoreIcon
          sx={{
            fill: getIconColour(),
          }}
        />
      )}
      {status === 'Promo' && (
        <LocalOfferIcon
          sx={{
            fill: getIconColour(),
          }}
        />
      )}
      {label && <StyledTypography {...labelProps}>{label}</StyledTypography>}
    </Box>
  );
};
